<template>
<div>
    <zm-row>
        <zm-button size="small" @click="showCreate()" class="btn-in-line" type="primary" v-if="hasPermission">Create Collection</zm-button>
    </zm-row>
    <zm-table :data="list" :row-class-name="tableRowClassName" v-loading="loading">
        <zm-table-column type="expand">
            <template slot-scope='scope'>
                <topic-list :topicNames="scope.row.realTopicNames" :isCollection="true"></topic-list>
            </template>
        </zm-table-column>
        <zm-table-column label="name" prop="name" show-overflow-tooltip></zm-table-column>
        <zm-table-column label="regex" prop="regex" show-overflow-tooltip></zm-table-column>
        <zm-table-column label="includeTopicNames" prop="includeTopicNames" show-overflow-tooltip>
            <template slot-scope='scope'>
                {{ scope.row.includeTopicNames ? scope.row.includeTopicNames.join() : '' }}
            </template>
        </zm-table-column>
        <zm-table-column label="excludeTopicNames" prop="excludeTopicNames" show-overflow-tooltip>
            <template slot-scope='scope'>
                {{ scope.row.excludeTopicNames ? scope.row.excludeTopicNames.join() : '' }}
            </template>
        </zm-table-column>
        <zm-table-column label="active" prop="active" width="60px">
          <template slot-scope='scope'>
            <i class='glyphicon' :class="{'zm-icon-ok':scope.row.active,'zm-icon-close':!scope.row.active}"></i>
          </template>
        </zm-table-column>
        <zm-table-column label="lastUpdateTime" prop="lastUpdateTime" :formatter="setTime"></zm-table-column>
        <zm-table-column label="createdTime" prop="createdTime" :formatter="setTime"></zm-table-column>
        <zm-table-column label="modifiedTime" prop="modifiedTime" :formatter="setTime"></zm-table-column>
        <zm-table-column prop="operate" label="operate" width="150px">
            <template slot-scope="scope">
                <zm-button size="small" class="btn-contain" type="icon" title="edit collection" icon="zm-icon-edit" v-if="hasPermission" @click="showEdit(scope.row)"></zm-button>
                <zm-button size="small" class="btn-contain" type="icon" title="enable collection" icon="zm-icon-play" v-if="!scope.row.active && hasPermission" @click="activeCollection(scope.row)"></zm-button>
                <zm-button size="small" class="btn-contain" type="icon" title="disable collection" icon="zm-icon-pause" v-if="scope.row.active && hasPermission" @click="activeCollection(scope.row)"></zm-button>
                <zm-button size="small" class="btn-contain" type="icon" title="remove collection" icon="zm-icon-delete" v-if="hasPermission" @click="removeCollection(scope.row.id)"></zm-button>
            </template>
        </zm-table-column>
    </zm-table>
    <div style="text-align: center" class="pagination-wrap">
        <zm-pagination @current-change="fetchData"
            @size-change="handleSizeChange"
            :current-page.sync="pageable.page" :page-size="pageable.size"
            :page-sizes="[10, 20, 50, 100, 500, 1000]"
            layout="sizes, total, prev, pager, next"
            :total="pageable.total">
        </zm-pagination>
    </div>
    <zm-dialog :title="form.id ? 'Edit Collection' : 'Create Collection'" :visible.sync="visible">
        <zm-form :model="form" :rules="rules" ref="form" label-width="180px">
            <zm-form-item prop="name">
                <div slot="label">
                    <tip label="name" id="topic-collection-name"></tip>
                </div>
                <zm-input v-model="form.name"></zm-input>
            </zm-form-item>
            <zm-form-item :prop="form.includeTopicNames.length ? '' : 'regex'">
                <div slot="label">
                    <tip label="regex" id="topic-collection-regex"></tip>
                </div>
                <zm-input v-model="form.regex"></zm-input>
            </zm-form-item>
            <zm-form-item prop="includeTopicNames">
                <div slot="label">
                    <tip label="includeTopicNames" id="topic-collection-includeTopicNames"></tip>
                </div>
                <zm-select v-model="form.includeTopicNames" allow-create multiple filterable clearable
                style="width: 100%" :loading="topicLoading" @change="onClickCheckValidate()">
                    <zm-option v-for="item in topicList" :key="item.id" :label="item.name" :value="item.name"></zm-option>
                </zm-select>
            </zm-form-item>
            <zm-form-item prop="excludeTopicNames">
                <div slot="label">
                    <tip label="excludeTopicNames" id="topic-collection-excludeTopicNames"></tip>
                </div>
                <zm-select v-model="form.excludeTopicNames" allow-create multiple filterable clearable style="width: 100%" :loading="topicLoading">
                    <zm-option v-for="item in topicList" :key="item.id" :label="item.name" :value="item.name"></zm-option>
                </zm-select>
            </zm-form-item>
            <zm-form-item label-width="0" prop="enable">
                <zm-checkbox v-model="form.enable">
                    <tip label="enable" id="topic-collection-enable"></tip>
                </zm-checkbox>
            </zm-form-item>
        </zm-form>
        <div slot="footer" class="dialog-footer">
            <zm-button type="primary" icon="zm-icon-ok" @click="save" :loading="loading">Save</zm-button>
            <zm-button @click="visible = false">Cancel</zm-button>
        </div>
    </zm-dialog>
</div>
</template>
<script>
import { getTopics } from '@/api'
import { listCollection, activeCollection, removeCollection, createCollection, updateCollection } from '@/api/collection'
import tip from 'components/ToolTip/index'
import topicList from '../topic/index'
export default {
    name: 'collection',
    components: {
        tip,
        topicList
    },
    data () {
        return {
            loading: false,
            hasPermission: localStorage.role === 'SUPER_ADMIN' || localStorage.role === 'ADMIN',
            list: [],
            topicLoading: false,
            topicList: [],
            form: {
                active: true,
                excludeTopicNames: [],
                includeTopicNames: [],
                name: '',
                regex: ''
            },
            visible: false,
            pageable: {
                page: 1,
                size: 10,
                total: 0
            },
            rules: {
                name: [
                    { required: true, message: 'please enter name', trigger: 'blur' }
                ],
                regex: [
                    { required: true, message: 'please enter regex', trigger: 'blur' }
                ]
            }
        }
    },
    created () {
        localStorage.params = ''
        localStorage.path = this.$route.path
        this.fetchData()
    },
    methods: {
        onClickCheckValidate () {
            this.$refs.form.validateField('regex')
        },
        save () {
            this.loading = true
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.loading = true
                    if (!this.form.id) {
                        createCollection(this.form).then(response => {
                            this.fetchData()
                            this.$message({
                                message: 'Create success!',
                                type: 'success'
                            })
                            this.visible = false
                            this.$refs.form.resetFields()
                        }).catch(() => {
                            this.loading = false
                        })
                    } else {
                        updateCollection(this.form.id, this.form).then(response => {
                            this.fetchData()
                            this.$message({
                                message: 'Edit success!',
                                type: 'success'
                            })
                            this.visible = false
                            this.$refs.form.resetFields()
                        }).catch(() => {
                            this.loading = false
                        })
                    }
                } else {
                    this.loading = false
                    this.$message({
                        message: 'Submit error!',
                        type: 'error'
                    })
                    return false
                }
            })
        },
        showCreate () {
            this.fetchTopics()
            this.form.id = ''
            this.form.name = ''
            this.form.regex = ''
            this.form.active = false
            this.form.includeTopicNames = []
            this.form.excludeTopicNames = []
            this.visible = true
        },
        showEdit (row) {
            this.fetchTopics()
            this.form.id = row.id
            this.form.name = row.name
            this.form.regex = row.regex
            this.form.active = row.active
            this.form.includeTopicNames = row.includeTopicNames
            this.form.excludeTopicNames = row.excludeTopicNames
            this.visible = true
        },
        fetchTopics () {
            if (!this.topicList.length) {
                this.topicLoading = true
                getTopics().then(response => {
                    this.topicLoading = false
                    this.topicList = response
                }).catch(() => {
                    this.topicLoading = false
                })
            }
        },
        activeCollection (row) {
            this.loading = true
            this.$confirm('This will change the status. Continue?', 'Warning', {
                confirmButtonText: 'Change',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.loading = true
                activeCollection(row.id, !row.active).then(response => {
                    this.fetchData()
                    this.$message({
                        message: 'Change status success!',
                        type: 'success'
                    })
                }).catch(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.loading = false
                this.$message({
                    type: 'info',
                    message: 'Change canceled'
                })
            })
        },
        removeCollection (id) {
            this.$confirm('This will remove the collection. Continue?', 'Warning', {
                confirmButtonText: 'Remove',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.loading = true
                removeCollection(id).then(response => {
                    this.loading = false
                    this.fetchData()
                    this.$message({
                        message: 'Remove success!',
                        type: 'success'
                    })
                }).catch(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.loading = false
                this.$message({
                    type: 'info',
                    message: 'Remove canceled'
                })
            })
        },
        fetchData () {
            this.loading = true
            listCollection(this.pageable.size, this.pageable.page - 1).then(response => {
                const { content, pageable: { page, size }, total } = response
                this.list = content
                this.pageable.total = total
                this.pageable.page = page + 1
                this.pageable.size = size
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        handleSizeChange (val) {
            this.pageable.size = val
            this.fetchData()
        },
        tableRowClassName ({ row, rowIndex }) {
            if (!row.active) {
                return 'warning-row'
            } else {
                return ''
            }
        },
        setTime (row, column, cellValue, index) {
            let time = row[column.property]
            return new Date(parseInt(time)).toLocaleString()
        }
    }
}
</script>
